import config from "../config/config";

const API = (config.API_URL || "").replace(/\/$/, "");
const KITE_BASE = "/api/kite";

export const KITE_URLS = {
  LOGIN:        `${API}${KITE_BASE}/login`,   // absolute — browser <a href> redirect
  STATUS:       `${KITE_BASE}/status`,
  ORDERS:       `${KITE_BASE}/orders`,
  POSITIONS:    `${KITE_BASE}/positions`,
  TRADES:       `${KITE_BASE}/trades`,
  OPTION_CHAIN: `${KITE_BASE}/option-chain`,
};
